import BrandListPageView from 'src/pages/BrandListPage/view'
import { QueryClient } from '@tanstack/react-query'
import { brandListQueryOption, useCustomQuery } from 'src/hooks/react-query/useCustomQuery.hook'
import { BrandListSpace, CategoryListSpace } from 'src/types/api'
import React, { useCallback, useState } from 'react'
import usePageNav from 'src/hooks/usePageNav.hook'

export interface BrandListPageProps {
  brandListData?: BrandListSpace.BrandInfoType[]
  categoryListData?: Pick<CategoryListSpace.CategoryInfoType, 'CategoryName' | 'CategoryNumber'>[]
  brandSalePageNav: (categoryNumber: number, brandNumber: number, brandName: string) => void
  categorySelectHandler: (categoryNumber: number) => void
  activeCategory: number
}
export const brandListPageLoader = (queryClient: QueryClient) => async () => {
  const dataQueryValues = [await queryClient.ensureQueryData(brandListQueryOption())]
  return Promise.allSettled(dataQueryValues)
}
const BrandListPage = () => {
  const { brandSalePageNav } = usePageNav()

  const { data: brandList, isSuccess: isBrandListSuccess } =
    useCustomQuery<BrandListSpace.Response>(brandListQueryOption())

  const [activeCategory, setActiveCategory] = useState<number>(
    brandList?.Body?.BrandInfo?.[0]?.CategoryNumber as number,
  )

  const updateCategoryItems = useCallback(() => {
    if (isBrandListSuccess && brandList?.Body?.BrandInfo) {
      return brandList.Body.BrandInfo.map(({ CategoryNumber, CategoryName }) => ({
        CategoryNumber,
        CategoryName,
      }))
    }
    return []
  }, [brandList, isBrandListSuccess])

  const props: BrandListPageProps = {
    brandListData: brandList?.Body?.BrandInfo,
    categoryListData: updateCategoryItems(),
    brandSalePageNav,
    activeCategory,
    categorySelectHandler: (categoryNumber: number) => setActiveCategory(categoryNumber),
  }

  return <BrandListPageView {...props} />
}
export default BrandListPage
